import React, { useEffect, useState } from "react";

import BaseCard from "../../../../../components/ui/BaseCard";
import AddEducationModal from "../../../components/AddEducationModal";
import { useDispatch } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";
import { showToast } from "../../../../../store/toast/toastSlice";
import {
  createEducation,
  deleteUserEducation,
  fetchUserEducationList,
  updateUserEducation,
} from "../../../../../services/api/education";
import dayjs from "dayjs";
import { EducationType } from "../../../../../utils/enum";

const AddEducation = ({ userId }) => {
  const dispatch = useDispatch();
  const [isAddEducationModalOpen, setIsAddEducationModalOpen] = useState(false);
  const [userEducation, setUserEducation] = useState([]);
  const [selectedUserEducation, setSelectedUserEducation] = useState();
  const isEdit = selectedUserEducation ? true : false;

  const {
    isPending: isDeleteEducationLoading,
    error: isDeleteEducationError,
    data: educationDeleteData,
    mutateAsync: deleteEducationMutation,
  } = useMutation({
    mutationFn: deleteUserEducation,
    enabled: false,
  });

  const {
    data: userEducationListData,
    isPending: isFetchEducationListLoading,
    error: isFetchEducationListError,
    refetch: refetchUserEducationList,
  } = useQuery({
    queryKey: ["userEducationList"],
    queryFn: () => fetchUserEducationList(userId),
    enabled: !!userId,
  });

  useEffect(() => {
    if (userEducationListData) {
      setUserEducation(userEducationListData?.data);
    }
  }, [userEducationListData]);

  const editEducationButtonClicked = (education) => {
    try {
      /*  formik.setValues({
        institutionName: education?.institutionName,
        educationType: education?.educationType,
        startDate: education?.startDate,
        endDate: education?.endDate,
      }); */
      setSelectedUserEducation(education);
      setIsAddEducationModalOpen(true);
    } catch (error) {}
  };

  const handleEducationDelete = async (id) => {
    try {
      const deleteEducationResponse = await deleteEducationMutation(id);

      const filteredUserEducation = userEducation.filter((education) => education.id !== id);
      setUserEducation(filteredUserEducation);
      dispatch(
        showToast({
          message: "Education deleted successfully",
          type: "success",
        }),
      );
    } catch (error) {}
  };

  return (
    <form>
      <BaseCard className="py-3 px-4 mt-3 border rounded-lg shadow-sm" elevation={0}>
        <div className="bg-light rounded-sm py-2 px-4 mb-4 flex items-center justify-between">
          <p className="text-base font-normal">Education</p>
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-secondary text-xl"
            onClick={() => setIsAddEducationModalOpen(true)}
          ></i>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4">
          {userEducation?.map((education) => (
            <div
              className="bg-light rounded-md py-3 px-4 flex justify-between gap-3 border"
              key={education.id}
            >
              <div className="min-w-0">
                <div className="flex flex-wrap mb-1.5">
                  <p className="font-medium mr-2">Institution Name: </p>
                  <p className="break-words">{education?.institutionName}</p>
                </div>
                <div className="flex flex-wrap mb-1.5">
                  <p className="font-medium mr-2">Education Type: </p>
                  <p className="break-words">{EducationType[education?.educationType]}</p>
                </div>
                <div className="flex flex-wrap gap-x-6">
                  <div className="flex">
                    <p className="font-medium">Start Date: </p>
                    <p className="ml-2">{dayjs(education?.startDate).format("DD/MM/YYYY")}</p>
                  </div>
                  <div className="flex">
                    <p className="font-medium">End Date: </p>
                    <p className="ml-2">{dayjs(education?.endDate).format("DD/MM/YYYY")}</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start shrink-0">
                <i
                  className="fa-regular fa-trash-can text-red-600 mr-3 cursor-pointer"
                  title="Delete"
                  onClick={() => handleEducationDelete(education.id)}
                ></i>
                <i
                  className="fa-light fa-pencil text-gray-900 cursor-pointer"
                  title="Edit"
                  onClick={() => editEducationButtonClicked(education)}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </BaseCard>

      {isAddEducationModalOpen && (
        <AddEducationModal
          open={isAddEducationModalOpen}
          close={setIsAddEducationModalOpen}
          refetchUserEducationList={refetchUserEducationList}
          isEdit={isEdit}
          setSelectedUserEducation={setSelectedUserEducation}
          selectedUserEducation={selectedUserEducation}
        />
      )}
    </form>
  );
};

export default AddEducation;
